<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <el-form-item label="预借单号" prop="advanceCode">
                            <el-input v-model="formInline.advanceCode" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="领域" prop="field">
                            <brselect category="swyl_field_new" :v="formInline.field" :showcode="true"
                                      v-model="formInline.field" clearable></brselect>
                        </el-form-item>
                        <el-form-item label="审批状态" prop="status">
                            <el-select v-model="formInline.status" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="暂存" value="0"></el-option>
                                <el-option label="待审核" value="1"></el-option>
                                <el-option label="审核通过" value="2"></el-option>
                                <el-option label="驳回" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="right-btn">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn" @click="createAdvance">新增预借</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="h-row T-jia">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            border
                            stripe
                            max-height="450"
                    >
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                fixed
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="advanceCode"
                                label="预借单号"
                                :show-overflow-tooltip="true"
                                width="180">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.advanceCode}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="field"
                                label="领域"
                                :show-overflow-tooltip="true"
                                width="150">
                            <template slot-scope="scope" >
                                {{scope.row.field|dictname('swyl_field_new')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="channelCode"
                                label="渠道"
                                :show-overflow-tooltip="true"
                                width="150">
                            <template slot-scope="scope" >
                                {{scope.row.channelCode|dictname('sales_region')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalMoney"
                                label="申请金额"
                                :show-overflow-tooltip="true"
                                width="150"
                        >

                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.totalMoney}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="状态"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template scope="scope">
                                <span v-if="scope.row.status == '0'">暂存</span>
                                <span v-if="scope.row.status == '1'">待审核</span>
                                <span v-if="scope.row.status == '2'">审核通过</span>
                                <span v-if="scope.row.status == '3'">驳回</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                :formatter="formatDate"
                                :show-overflow-tooltip="true"
                                width="180"
                        >
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                fixed="right"
                                width="280"
                        >
                            <template slot-scope="scope">
                                <div class="w-caozuo" style="text-align: left;">
                                    <el-button
                                            type="text"
                                            size="small"
                                            v-if="scope.row.status == 0"
                                            class="h-tableLink h-btn" @click="editAdvance(scope.row,1)">
                                         编辑
                                    </el-button>
                                    <el-button
                                            type="text"
                                            size="small"
                                            v-if="scope.row.status == 3"
                                            class="h-tableLink h-btn" @click="editAdvance(scope.row,2)">
                                        重新提交
                                    </el-button>
                                    <el-button
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn" @click="editAdvance(scope.row,3)">
                                        查看详情
                                    </el-button>
                                    <el-button v-if="scope.row.instid"
                                               size="small" class="h-tableLink h-btn"
                                               @click="genzongLiuch(scope.row)">
                                        跟踪
                                    </el-button>
                                </div>


                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
<!--                <div class="h-tableBL" v-auth="'plldan'">
                    &lt;!&ndash;                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>&ndash;&gt;
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn">批量导入
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="orderResourcePoolExcel"
                                     :startrow="1" @callback="uploadExcelFilecallback"/>
                </div>-->
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="createDialog" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{titleDig}}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;" class="dialogout pool">
                        <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                            <div>
                                <el-form-item label="补足资源池亏损金额" >
                                    <el-input v-model="add.supplyMoney" @change="chageSupply"></el-input>
                                </el-form-item>
                  <!--              <el-button @click="addPro()" type="text" size="mini"
                                           style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus"
                                           circle></el-button>-->
                                <div v-for="(listIt, index) in add.detailList" :key="index" class="h-formBox">
                                    <el-button @click="deletePro(index)" v-show="index != 0" type="text"
                                               style="float:right;font-size:20px;margin-right: -5px;color:crimson;" size="mini"
                                               icon="el-icon-remove" circle></el-button>
<!--                                    <el-form-item label="项目名称" style="margin-left: -15px; margin-right: -15px">
                                        <el-input v-model="add.detailList[index].projectName" disabled></el-input>
                                    </el-form-item>-->

                                    <el-form-item label="项目名称" class="h-elformWrap-2">
                                        <el-select v-model="add.detailList[index].projectName" :title="add.detailList[index].projectName" remote
                                                   filterable :disabled="updateFlag" placeholder="请输入" @change="changePro($event,index)">
                                            <el-option v-for="(item,index) in proList"
                                                       :key="item.id"
                                                       :label="item.projectNameLike"
                                                       :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="特价版本号" style="margin-left: -15px; margin-right: -15px">
                                        <el-input v-model="add.detailList[index].specialCode" disabled></el-input>
                                    </el-form-item>

<!--                                    <el-form-item label="特价版本号" class="h-elformWrap-2 danwei">
                                        <el-select v-model="add.detailList[index].specialCode" :title="add.detailList[index].proModel" remote
                                                   filterable :disabled="updateFlag" placeholder="请输入" @change="changePro($event,index)">
                                            <el-option v-for="(item,index) in proList"
                                                       :key="index"
                                                       :label="item.tid"
                                                       :value="item.tid">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>-->

                                    <el-form-item label="渠道" class="h-elformWrap-2">
                                        <el-select v-model="add.detailList[index].channelCode" :title="add.detailList[index].channelCode" remote
                                                   filterable :disabled="updateFlag" placeholder="请输入" @change="getBalance($event)">
                                            <el-option v-for="(item,index) in add.detailList[index].customerChannelListFilter"
                                                       :key="item.code"
                                                       :label="item.name"
                                                       :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="项目金额" style="margin-left: -15px; margin-right: -15px">
                                        <el-input v-model="add.detailList[index].projectMoney" disabled></el-input>
                                    </el-form-item>

                                    <el-form-item label="预借金额">
                                        <el-input v-model="add.detailList[index].advanceMoney" disabled></el-input>
                                    </el-form-item>


                                    <el-form-item label="项目必要性及关差方案" style="width: 100%;">
                                        <el-input v-model="add.detailList[index].advancePlan" :disabled="updateFlag" type="textarea" style="border: #dedede 1px solid;width: 200%;" ></el-input>
                                    </el-form-item>

                                </div>

                                <el-form-item label="本月合计预借金额" >
                                    <el-input v-model="add.totalMoney" disabled></el-input>
                                </el-form-item>

                                <el-form-item label="附件" class="h-elformWrap-2" required>
                                    <brupload
                                            v-model="add.fileUrl"
                                            :refid=testID
                                            reftype="YJ_FIEL"
                                            :limit="1"
                                            :showtime="false"
                                            :uploadflag="!updateFlag"
                                            delflag
                                            @filecallback=mfIsUpload>
                                    </brupload>
                                </el-form-item>
                            </div>

                        </el-form>
                    </div>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" v-if="!updateFlag && !subFlag" @click="commitUpdate(1)">暂存</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" v-if="!subFlag && !updateFlag" @click="commitUpdate(2)">提交</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" v-if="subFlag && !updateFlag" @click="commitUpdate(3)">重新提交</el-button>
                    </div>
                </div>
            </el-dialog>
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from '../../../utils/updownfile'
    import big from 'big.js'
    export default {
        components: {
            uploaddownexcel,
            updownfile,
        },
        data() {
            return {
                tableData2:[],
                formInline: {
                    advanceCode: null,
                    status: '',
                    field:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                add: {
                    detailList:[{
                        projectId:null,
                        projectName:null,
                        specialCode:null,
                        channelCode:null,
                        projectMoney:null,
                        advanceMoney:null,
                        advancePlan: null,
                        fileUrl:null,
                        advanceCode:null,
                        customerChannelListFilter:[],
                    }],
                    totalMoney:0,
                    supplyMoney:0,
                    refid:null,
                    submitFlag: null,
                    id:null,
                },
                uploaddownexcelflag:false,
                showOrhide:false,
                createDialog: false,
                proList:[],
                testID:null,
                titleDig: null,
                subFlag: false,
                updateFlag: false,
                showhistory: false,
                instid: null,
                customerChannelList:[],
                data3:[],
            }
        },
        //加载页面默认执行
        created() {
            this.query();
            this.getProList();
            this.testID = this.$util.getUuid();
            this.customerChannelList = this.$store.getters.dictlist("sales_region");
        },
        mounted() {

        },
        methods: {
            /*// 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },*/
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            //重置
            resetData(){
                this.formInline.status = null;
                this.formInline.advanceCode = null;
                this.formInline.field = null;
            },
            //检索
            query(){
                ss.resourcePool.selectAdPage(this.formInline).then(rd => {
                    this.tableData2 = rd.records;
                    this.formInline.total = rd.total;
                })
            },
            //取消
            exit() {
                this.closeDialog()
            },
            //重置
            closeDialog(){
                this.createDialog = false;
                this.add.detailList = [{
                    projectId:null,
                    projectName:null,
                    specialCode:null,
                    channelCode:null,
                    projectMoney:0,
                    advanceMoney:0,
                    advancePlan: null,
                    customerChannelListFilter: [],
                }]
                this.add.totalMoney = 0;
                this.add.supplyMoney = 0;
                this.add.refid = null;
                this.add.submitFlag = null;
                this.add.advanceCode = null;
                this.add.id = null;
                this.testID = this.$util.getUuid();
                this.subFlag = false;
                this.updateFlag = false;
            },
/*            //导入
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback() {
                this.query();
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/resourcePool/downloadExcel",this.formInline,"post",'data');
            },*/
            dateFormatter(v){
                var now = new Date(v);
                var year=now.getFullYear();
                var month = now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1;
                var alldata2 =  year+"-"+month;
                return alldata2;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            createAdvance(){
                this.createDialog = true;
                this.titleDig = '新增预借';
                this.getBalance();
            },
            getProList(){
                var data = {}
                ss.resourcePool.selectProList(this.data).then(rd => {
                    this.proList = rd.msg;
                    this.proList.forEach()
                })
            },
            changePro(value, index){
                this.add.detailList[index].customerChannelListFilter=[];
                var pro = _.find(this.proList, {id: value});
                this.add.detailList[index].specialCode = pro.tid;
                this.add.detailList[index].projectMoney = pro.projectMoney;
                this.add.detailList[index].advanceMoney = pro.advanceMoney;
                this.add.detailList[index].projectId = pro.id;
                // 设置客户渠道，
                var proChannelList = _.filter(this.customerChannelList, (o) => {
                    return _.split(pro.customerChannel || '', ",").includes(o.code);
                });
                ss.UserAuthService.getUserAuthList({usercode:this._user.usercode}).then(rd=>{
                    this.data3 = _.map(rd["obj"]["3"],"code");
                    for(var i =0;i<this.data3.length;i++){
                        for(var j=0;j<proChannelList.length;j++){
                            if(proChannelList[j].code==this.data3[i]){
                                this.add.detailList[index].customerChannelListFilter.push(proChannelList[j])
                              console.log("proChannelList",this.add.detailList[index].customerChannelListFilter)
                            }
                        }
                    }
                    this.add.detailList[index].channelCode = this.add.detailList[index].customerChannelListFilter[0].code;


                    var totalMoney = 0;
                    for(var i = 0;i<this.add.detailList.length;i++){
                        var ad = this.add.detailList[i];
                        totalMoney = totalMoney + ad.advanceMoney;
                    }
                    this.add.totalMoney = Number(totalMoney) + Number(this.add.supplyMoney);

                  //根据渠道获取补足资源池亏损金额
                  this.getBalance(this.add.detailList[index].channelCode);
                })


            },
            addPro(){
                this.add.detailList.push({
                    projectName:null,
                    specialCode:null,
                    channelCode:null,
                    projectMoney:null,
                    advanceMoney:null,
                    advancePlan: null,
                })
            },
            deletePro(index){
                this.add.totalMoney = this.add.totalMoney - this.add.detailList[index].advanceMoney;
                this.add.detailList.splice(index, 1);
            },
            mfIsUpload(v){
                console.log('mfIsUpload',v)
                if (v.length > 0) {
                    let arrnew = []
                    v.forEach(e => {
                        this.add.refid = e.saveurl
                    })
                }else{
                    this.add.refid =null;
                }
            },
            commitUpdate(v){
                if(v == 1){
                    this.add.submitFlag = '暂存';
                }else if(v == 2){
                    this.add.submitFlag = '提交';
                }else if(v == 3){
                    this.add.submitFlag = '重新提交';
                }

                var data = {};
                data.detailList = this.add.detailList;
                data.submitFlag = this.add.submitFlag;
                data.totalMoney = this.add.totalMoney;
                data.supplyMoney = this.add.supplyMoney;
                if(this.add.id != null || this.add.id != ''){
                    data.id = this.add.id;
                }
                if(this.add.advanceCode != null || this.add.advanceCode != ''){
                    data.advanceCode = this.add.advanceCode;
                }
                data.refid = this.testID;

                ss.resourcePool.submitAdvance(data).then(rd =>{
                    if(rd.f){
                        this.closeDialog();
                        this.query();
                    }
                })
            },
            editAdvance(v,a){
                var data = {};
                data.id = v.id;
                if(a == 2){
                    this.subFlag = true;
                }
                if(a == 3){
                    this.updateFlag = true;
                }
                ss.resourcePool.getAdvanceDetail(data).then(rd=>{
                    if(rd.f){
                        this.add = rd.msg;
                        this.add.detailList.forEach((item, index) => {
                            this.add.detailList[index].customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
                                return _.split( this.add.detailList[index].channelCode || '', ",").includes(o.code);
                            });
                        })
                        this.testID = rd.msg.id;
                        this.createDialog = true;
                        this.titleDig = '编辑预借';
                    }
                })
            },
            genzongLiuch(r) {
                console.log(r);
                if (r.orderCategory == '1' || r.orderCategory == '3') {
                    this.instid = r.binstid;
                } else {
                    this.instid = r.instid;
                }
                this.showhistory = true;
            },
            chageSupply(v){
              console.log("this.add.detailList",this.add.detailList)
                if(v == '' || v==null){
                    var totalMoney = 0;
                    for(var i = 0;i<this.add.detailList.length;i++){
                        var ad = this.add.detailList[i];
                        totalMoney = totalMoney + ad.advanceMoney;
                    }
                    this.add.totalMoney = totalMoney;
                }else if(v != null){
                    var totalMoney = 0;
                    for(var i = 0;i<this.add.detailList.length;i++){
                        var ad = this.add.detailList[i];
                        totalMoney = totalMoney + ad.advanceMoney;
                    }
                    this.add.totalMoney = Number(totalMoney) + Number(this.add.supplyMoney);
                }

            },
          //根据领域查询当月补足资源池亏损金额
          getBalance(channels){
            var data = {};
            data.channels = channels;
              ss.resourcePool.getBalance(data).then(rd => {
                this.add.supplyMoney = rd.msg;

                var totalMoney = 0;
                for(var i = 0;i<this.add.detailList.length;i++){
                  var ad = this.add.detailList[i];
                  totalMoney = totalMoney + ad.advanceMoney;
                }
                this.add.totalMoney = Number(totalMoney) + Number(this.add.supplyMoney);



              })
          },
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }

    /* 兼容 */
    /deep/ .h-formbLine .el-form-item__label {
        width: 110px;
    }

    /deep/ .h-formbLine .el-form-item__content {
        width: 110px;
    }

    .h-dialog2{

    }
    .h-dialog2 .h-dialogImg {
        height: 1.62rem;
        background:#007fd8 url(/img/h-dialogImg.471fa846.png) left no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }
    .h-dialog2 /deep/.el-dialog{
        width: 8.5rem ;
        margin: 0 auto;
    }
    .h-dialog2 .el-dialog__body{
        padding: 1rem 0;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;

        }
        .steps{
            position: absolute;
            z-index: 1;

        }
        .step1{
            top: 0;
            left: 0;

        }
        .step2{
            top: 0;
            right: 0;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }

        .pool .h-formbLine .h-elformWrap-2 {
            padding-right: 0.1rem;
            width: 50%;
        }
        .pool .h-formbLine .h-elformWrap-3 {
            padding-right: 0.1rem;
            width: 47% !important;
        }
        .pool .h-formbLine .h-elformWrap-4 {
            padding-right: 0.2rem;
            width: 48%;
        }
        .pool .h-formbLine .h-elformWrap-1 {
            padding-right: 0;
            width: 100% !important;
        }
        .pool .h-formbLine .h-elformWrap-1 .el-form-item__label{
            width: 22%;
        }
        .pool .h-formbLine .h-elformWrap-1 .el-form-item__content{
            width: 78%;
        }
        .pool .h-formbLine .h-elformWrap-4 .el-form-item__content{
            width: 65%;
        }
        .pool .h-formbLine .h-elformWrap-3 .el-form-item__label{
            width: 16%;
        }
        .pool .h-formbLine .h-elformWrap-3 .el-form-item__content{
            width: 82%;
        }
        .pool .h-formbLine .danwei .el-input{
            width:10%
        }
        .pool .h-formbLine .el-form-item__label {
            width:auto;
        }
        .pool .h-formbLine .el-form-item__content {
            width: 49%;
        }
    }
</style>
